export default __webpack_public_path__ + "static/media/vip5.d71e4978.webp";